// components/PlatformFilter.js
import React from "react";
// import "./PlatformFilter.css";

export default function PlatformFilter({
  platforms,
  selectedPlatforms,
  onChange,
}) {
  const handleCheckboxChange = (platform) => {
    const updated = selectedPlatforms.includes(platform)
      ? selectedPlatforms.filter((p) => p !== platform)
      : [...selectedPlatforms, platform];

    onChange(updated); // This should update Firebase via parent component
  };

  return (
    <div className="platform-filter">
      <div className="toggle-group">
        <div className="label">Platforms</div>
        {platforms
          .filter((p) => p !== "All")
          .map((platform) => (
            <label
              key={platform}
              className={`toggle-button ${
                selectedPlatforms.includes(platform) ? "checked" : ""
              }`}
            >
              <input
                type="checkbox"
                checked={selectedPlatforms.includes(platform)}
                onChange={() => handleCheckboxChange(platform)}
              />
              {platform}
            </label>
          ))}
      </div>
    </div>
  );
}
